<mat-card appearance="outlined">
    @switch (inputType()) {
        <!-- DATE EDITOR -->
        @case ("DATE") {
            <form class="fix-editor">
                <mat-form-field class="ag-row fix-mat-form" [style.width]="width()">
                    <input
                        matInput
                        [formControl]="dateFormControl"
                        [matDatepicker]="picker"
                        (keydown.space)="onSpacebarClick($event)"
                        [focusSelectOn]="cellReady()"
                    />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker panelClass="ag-custom-component-popup se-ui-dateTimePickerEditor">
                    </mat-datepicker>
                </mat-form-field>
                <!-- <mat-calendar
                    class="se-ui-dateTimePickerEditor"
                    [selected]="setDateValue()"
                    (selectedChange)="updateDate($event)"
                >
                </mat-calendar> -->
            </form>
        }
        @case ("TIME") {
            <se-time-picker
                class="cp-input"
                [appearance]="'fill'"
                [timeFormat]="timeInputFormat"
                [gridClass]="'ag-row fix-mat-form'"
                [isWithLabel]="false"
                [showIcon]="false"
                [showResetButton]="false"
                [time]="getValue()"
                [customPanelClass]="'ag-custom-component-popup'"
                (timeChange)="updateModel($event)"
                [focusSelectOn]="cellReady()"
            >
            </se-time-picker>
        }
        @case ("DATE_TIME") {
            <se-datetime-picker
                class="cp-input"
                [appearance]="'fill'"
                [gridClass]="'ag-row fix-mat-form'"
                [isWithLabel]="false"
                [showResetButton]="false"
                [showIcon]="false"
                [dateTime]="getValue()"
                [customPanelClass]="'se-ui-dateTimePickerEditor ag-custom-component-popup'"
                (dateTimeChange)="updateModel($event)"
                [focusSelectOn]="cellReady()"
            >
            </se-datetime-picker>
        }
    }
</mat-card>
